import React, { useMemo } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { MENU } from '../constants/index';
import { caseList, CaseCard } from '../source/index';

const useStyles = makeStyles(() => ({
  case: {
    padding: '42px 50px',
    background: '#fff',
    '& h1': {
      fontSize: 42,
      textAlign: 'center'
    },
    '& > div': {
      paddingTop: 56,
    },
    '@media (max-width: 1260px)': {
      padding: '0 0 60px 0'
    }
  },
  btn: {
    textAlign: 'center',
    '& button': {
      width: 128,
      height: 40,
      color: '#9595cc',
      background: '#fff',
      border: '1px solid #9595cc',
      cursor: 'pointer',
      '&:hover': {
        background: '#fffafa'
      }
    }
  }
}));

const cardUseStyles = makeStyles(() => ({
  card: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    '& + &': {
      marginTop: 42,
    },
    '& img': {
      height: 155,
      marginRight: 24
    },
    '& > div': {
      flex: 1,
      display: 'flex',
      flexDirection: 'column'
    },
    '& h2': {
      color: '#333',
      fontSize: 28,
      margin: 0,
    },
    '& > div > h2': {
      display: '-webkit-box',
      boxOrient: 'vertical',
      lineClamp: 2,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
    '& > div > div': {
      color: '#666',
      fontSize: 18,
      marginTop: 16,
      display: '-webkit-box',
      boxOrient: 'vertical',
      lineClamp: 4,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
    '@media (max-width: 1260px)': {
      '& img': {
        width: 200,
        height: 194,
        marginRight: 12
      },
    }
  },
}));

const CardComponent: React.FC<{ data: CaseCard }> = ({ data }) => {
  const classes = cardUseStyles();

  return (
    <div className={classes.card}>
      <img src={data.img} alt="" />
      <div>
        <h2>{data.name}</h2>
        <div>{data.info}</div>
      </div>
    </div>
  );
};

const CaseComponent: React.FC<{ menuKey?: string, setMenu?: React.Dispatch<React.SetStateAction<string>> }> = ({ menuKey, setMenu }) => {
  const classes = useStyles();
  const isShowInHome = useMemo(() => menuKey === MENU.home, [menuKey]);
  const cardData = useMemo(() => isShowInHome ? caseList.slice(0, 2) : caseList, [isShowInHome]);

  return (
    <div className={classes.case}>
      {isShowInHome && <h1>成功案例</h1>}
      <div>
        { cardData.map((data, index) => <CardComponent key={`card${index}`} data={data} />) }
      </div>
      {
        isShowInHome &&
        <div className={classes.btn}>
          <button onClick={() => setMenu?.(MENU.consult)}>了解更多</button>
        </div>
      }
    </div>
  );
}

export default CaseComponent;